import z from 'zod'

import { zodErrorParser } from '@/utils/zod'
import { SystemUserRoles } from './Organization'
import { UserResponseSchema } from './User'

const DelegateStatuses = [
  'ACTIVE',
  'INACTIVE',
] as const

const DelegateResponseSchema = z.object({
  status: z.enum(DelegateStatuses),
  type: z.enum(SystemUserRoles),
  user: UserResponseSchema.extend({
    subject: z.uuid().nullish(),
  })
}).strict()

export type DelegateResponse = z.infer<typeof DelegateResponseSchema>

export const zodDelegateResponseValidator = (
  data: DelegateResponse[]
) => zodErrorParser(
  'DelegateResponse',
  DelegateResponseSchema,
  data,
)
